<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title="AUPA"
      title="AgroUPAdvisor"
    >
      <template v-slot:links>
        <sidebar-item
          :link="{
            name: $t('dashboard_layout.dashboardItemName'),
            icon: 'ni ni-tv-2 text-primary',
            path: '/dashboard',
          }"
        />

        <sidebar-item
          :link="{
            name: $t('dashboard_layout.terrainsItemName'),
            icon: 'bi bi-globe text-blue',
            path: '/terrains',
          }"
        />
        <sidebar-item
          :link="{
            name: $t('dashboard_layout.plotsItemName'),
            icon: 'bi bi-diagram-3-fill text-orange',
            // icon: 'ni ni-pin-3 text-orange',
            path: '/plots',
          }"
        />
        <sidebar-item
          :link="{
            name: $t('dashboard_layout.modulesItemName'),
            icon: 'bi bi-router-fill text-yellow',
            path: '/modules',
          }"
        />
        <!-- <sidebar-item
          :link="{
            name: 'Alarmes',
            icon: 'ni ni-bullet-list-67 text-red',
            path: '/tables',
          }"
        /> -->
        <sidebar-item
          :link="{
            name: $t('dashboard_layout.graphicsItemName'),
            icon: 'bi bi-bar-chart-line-fill text-info',
            path: '/graphics',
          }"
        />
        <sidebar-item
          :link="{
            name: $t('dashboard_layout.accountItemName'),
            icon: 'ni ni-circle-08 text-pink',
            path: '/account',
          }"
        />
      </template>
    </side-bar>
    <div id="main-content" class="main-content" 
      :class="classToggler()"
     :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <!-- your content here -->
        <router-view></router-view>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
    <div v-if="$sidebar.showSidebar" class="overlay"></div>
  </div>
</template>
<script>
import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
  },
  data() {
    return {
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary
    };
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    classToggler(){
      let classList = ''
      if(!this.$isMobile()){
        classList += 'collapsed-sidebar '
      }
      if(this.$sidebar.showSidebar){
        classList += 'menu-open'
      }
      return classList
    }
  },
};
</script>
<style>
.collapsed-sidebar {
  margin-left: 70px !important;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0); /* Dimmer color and opacity */
  opacity: 0.3;
  pointer-events: none; /* Make overlay not clickable */
}

.menu-open .overlay {
  opacity: 1 !important;
  pointer-events: auto !important;
}
</style>
